export default __webpack_public_path__ + "static/media/money.a7172e0a.svg";